export default __webpack_public_path__ + "static/gcalendar-hero-img-1ea5afe7c15e425e517d58254407a999.png";